module.exports = __webpack_public_path__ + "img/visa.8bfb1d4b.png";